import React from 'react';

const InsuranceClaim = () => (
  <svg
    width='60'
    height='61'
    viewBox='0 0 60 61'
    fill='none'
    style={{ marginLeft: '-10px' }}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.8008 38.022V11.242H27.9808V51.1814L14.8447 43.6982C14.8433 43.6974 14.8419 43.6966 14.8405 43.6958C13.0211 42.6323 11.8008 40.462 11.8008 38.022Z'
      fill='#DFF3B2'
      stroke='#06292F'
      stroke-width='2'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M49.8011 10.242V38.022C49.8011 40.782 48.4211 43.302 46.2611 44.562L31.6211 52.902V10.242H49.8011Z'
      fill='#06292F'
    />
    <path
      d='M30.7199 40.7819C36.6846 40.7819 41.5199 35.9466 41.5199 29.9819C41.5199 24.0173 36.6846 19.1819 30.7199 19.1819C24.7552 19.1819 19.9199 24.0173 19.9199 29.9819C19.9199 35.9466 24.7552 40.7819 30.7199 40.7819Z'
      fill='white'
    />
    <path
      d='M28.5001 36.582L23.5801 31.602L26.1001 29.022L28.5001 31.482L35.3401 24.642L37.9201 27.162L28.5001 36.582Z'
      fill='#97D700'
      stroke='#06292F'
      stroke-width='2'
    />
  </svg>
);

export default InsuranceClaim;
